import { render } from "./PublicPage.vue?vue&type=template&id=7080620a&scoped=true"
import script from "./PublicPage.vue?vue&type=script&lang=js"
export * from "./PublicPage.vue?vue&type=script&lang=js"

import "./PublicPage.vue?vue&type=style&index=0&id=7080620a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Loïc\\Downloads\\smsyou\\avalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7080620a"]])

export default __exports__